import { ROLE_IDS } from '../constants';
import { useAppSelector } from './reduxStoreHooks';

type Props = {
  onlyAdmin?: boolean;
};

export default function useCheckUserIfLoggedUserIsLicensed({
  onlyAdmin = false,
}: Props = {}) {
  const userAccount = useAppSelector((state) => state.user.userAccountData);

  const userIsLicensed = onlyAdmin
    ? userAccount?.roleId === ROLE_IDS.LICENSED_ADMIN
    : userAccount?.roleId === ROLE_IDS.LICENSED_ADMIN ||
      userAccount?.roleId === ROLE_IDS.LICENSED_MEMBER;

  return userIsLicensed;
}
